import API from '../api/scanner';

/**
 * Constants
 */

export const SCAN_OK = "scanner/SCAN_OK";
export const SCAN_FAILED = "scanner/SCAN_FAILED";

// For fetching the data
export const FETCHING = "scanner/FETCHING";
export const FETCHING_OK = "scanner/FETCHING_OK";
export const FETCHING_FAILED = "scanner/FETCHING_FAILED";


/**
 * Action Creators
 */
export function scanSuccess(result) {
    return {
        type: SCAN_OK,
        result
    };
}

export function scanError(err) {
    return {
        type: SCAN_FAILED,
        err
    }
}

export function fetchGuest(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: FETCHING });
            const guest = await API.fetchGuest(id);
            dispatch({
                type: FETCHING_OK,
                data: guest.data
            });
        } catch (err) {
            dispatch({
                type: FETCHING_FAILED,
                err: err.response || err.message
            });
        }
    }
}


/**
 * Reducer
 */
const initialState = {
    success: false,
    error: false,
    result: '',
    isFetching: false,
    data: false
};

export default function scanner(state = initialState, action) {
    switch (action.type) {
        case SCAN_OK:
            return {
                success: true,
                result: action.result,
                error: false
            };
        
        case SCAN_FAILED:
            return {
                ...initialState,
                error: action.err
            };
        
        case FETCHING:
            return {
                ...state,
                isFetching: true,
                error: false
            };
        
        case FETCHING_OK:
            return {
                ...state,
                isFetching: false,
                data: action.data,
                success: false,
                error: false
            };
        
        case FETCHING_FAILED:
            return {
                ...state,
                isFetching: false,
                data: false,
                error: action.err,
                success: false
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/scanner.js